// eslint-disable-next-line no-unused-vars
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import React from 'react';
import ApexFundingAccountVerificationTemplate
  from 'Views/Page/Content/Templates/ApexFundingAccountVerificationTemplate/index';
import ApexFundingAccountVerificationActivationTest
  from 'Views/Page/Content/Templates/ApexFundingAccountVerificationTemplate/ApexFundingAccountVerificationActivationTest/ApexFundingAccountVerificationActivationTest';

const ApexFundingAccountVerificationTemplatePicker = ({ resource, ...props }) => {
  return pickWithPriority(resource, [
    [fr.relationships.activationTest.name, <ApexFundingAccountVerificationActivationTest resource={resource} {...props} />],
  ], <ApexFundingAccountVerificationTemplate resource={resource} {...props} />);
};

export default ApexFundingAccountVerificationTemplatePicker;
